<h2>Product Mapping</h2>

<div class="px-2 py-3 contents h-full max-h-80" *ngIf="isLoadProductMappingGridDataSource">
    <div class="flex pb-4 justify-start">
        <dx-check-box [value]="false" text="Include deactivated Product Mapping items" class="pr-2" (onValueChanged)="extraFilteringOptionsChange('Active', $event)"></dx-check-box>
        <dx-check-box [value]="false" text="Include omitted / saved Categories" class="pr-2" (onValueChanged)="extraFilteringOptionsChange('SourceCategoryIsExcluded', $event)"></dx-check-box>
        <dx-check-box [value]="false" text="Include omitted / saved Companies" class="pr-2" (onValueChanged)="extraFilteringOptionsChange('SourceCompanyIsExcluded', $event)"></dx-check-box>
        <dx-check-box [value]="false" text="Include omitted / saved Master Brands" class="pr-2" (onValueChanged)="extraFilteringOptionsChange('SourceMasterBrandIsExcluded', $event)"></dx-check-box>
    </div>
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid #productMappingDataGrid id="gridContainer"
                      [allowColumnResizing]="true"
                      [columnResizingMode]="'widget'"
                      [allowColumnReordering]="true"
                      [dataSource]="productMappingDataSource"
                      [showBorders]="true"
                      [columnAutoWidth]="true"
                      [remoteOperations]="true"
                      [masterDetail]="{ enabled: true, template: 'detail' }"
                      [hoverStateEnabled]="true"
                      (onRowExpanding)="onRowExpanding($event)"
                      (onRowExpanded)="onRowExpanded($event)"
                      (onSelectionChanged)="selectionChangedHandler()"
                      (onContentReady)="onReady($event)"
                      (onContextMenuPreparing)="productMappingDataContextMenu($event)"
                      [cacheEnabled]="false"
                      keyExpr="ServiceAndProductMappingId">
            <dxo-state-storing [enabled]="true"
                               type="custom"
                               [customLoad]="loadMappingState"
                               [customSave]="saveMappingState">
            </dxo-state-storing>
            <dxo-sorting mode="single"></dxo-sorting>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-load-panel [enabled]="false"
                            shadingColor="rgba(0,0,0,0.4)"
                            [showIndicator]="true"
                            [showPane]="true"
                            [shading]="true">
            </dxo-load-panel>
            <dxo-column-chooser [enabled]="true"
                                mode="dragAndDrop">
                <!-- or "select" -->
            </dxo-column-chooser>
            <dxo-pager [visible]="true"
                       [allowedPageSizes]="[5, 10, 25, 50, 100]"
                       displayMode="compact"
                       [showPageSizeSelector]="true"
                       [showNavigationButtons]="false">
            </dxo-pager>

            <dxi-column dataField="ServiceAndProductMappingId" [allowHeaderFiltering]="false" [width]="140" caption="Product Mapping Id" [customizeText]="customizeProductMappingId"></dxi-column>
            <dxi-column caption="Action" [allowHeaderFiltering]="false" [width]="90" cellTemplate="action" alignment="center"></dxi-column>
            <dxi-column caption="Source Data - Category and Brand">
                <dxi-column dataField="SourceCategory" caption="Category" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="SourceSubcategory" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="SourceDescription" caption="Description" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="SourceCompany" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="SourceMasterBrand" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="SourceBrand" caption="Brand" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="SourceSubBrand" caption="Sub-brand" [allowHeaderFiltering]="false"></dxi-column>
            </dxi-column>
            <dxi-column caption="Source Data - Product Size">
                <dxi-column dataField="SourceSize" caption="Size" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="SourceUnitOfMeasure" caption="UoM" [allowHeaderFiltering]="false"></dxi-column>
            </dxi-column>
            <dxi-column caption="Source Data - Barcode">
                <dxi-column dataField="SourceBarcode" caption="Source Barcode" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="CleanBarcode" caption="Clean Barcode" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="IsValidBarcode" caption="Is Valid" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="IsVerifiedBarcode" caption="Is Verified" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="ProductMasterInconsistentWithBarcode" caption="Barcode Inconsistent" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="BarcodeMappingModeName" caption="Mapping Mode Name" [allowHeaderFiltering]="false"></dxi-column>
            </dxi-column>
            <dxi-column caption="Data Auditing">
                <dxi-column dataField="CreatedOn" format="d/M/yyyy, HH:mm" dataType="datetime" caption="Created on" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created by">
                    <dxo-header-filter [dataSource]="createdByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified by">
                    <dxo-header-filter [dataSource]="modifiedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedOn" format="d/M/yyyy, HH:mm" dataType="datetime" caption="Modified on" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="modifiedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed by">
                    <dxo-header-filter [dataSource]="reviewedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedOn" format="d/M/yyyy, HH:mm" dataType="datetime" caption="Reviewed on" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column dataField="Active" caption="Is Active" [allowHeaderFiltering]="false"></dxi-column>
            <!--<dxi-column dataField="BarcodeMappingModeId" caption="Barcode Mapping Mode Id" [allowHeaderFiltering]="false"></dxi-column>-->
            <dxi-column dataField="BrandId" caption="Brand Id" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="BrandName" caption="Brand Name">
                <dxo-header-filter [dataSource]="brandNameMappingHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CategoryId" caption="Category Id" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="CategoryName" caption="Category Name">
                <dxo-header-filter [dataSource]="categoryNameMappingHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CompanyId" caption="Company Id" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="CompanyName" caption="Company Name">
                <dxo-header-filter [dataSource]="companyNameMappingHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="MappingModeName" caption="Mapping Mode Name" [allowHeaderFiltering]="false">
            </dxi-column>
            <dxi-column dataField="MappingAssignedToUserFullNameSortableOrPrincipalName" caption="Mapping Assigned">
                <dxo-header-filter [dataSource]="mappingAssignedHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <!--<dxi-column dataField="MappingModeId" caption="Mapping Mode" [alignment]="'left'">
        <dxo-header-filter [dataSource]="mappingModeNameHeaderDataSource"></dxo-header-filter>
    </dxi-column>-->
            <dxi-column dataField="MappingPriority" caption="Mapping Priority">
                <dxo-header-filter [dataSource]="mappingPriorityHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="MasterBrandId" caption="Master Brand Id" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="MasterBrandName" caption="Master Brand Name">
                <dxo-header-filter [dataSource]="masterBrandNameMappingHeaderDataSource"></dxo-header-filter>
            </dxi-column>

            <div *dxTemplate="let action of 'action'">
                <dx-button class="mr-1"
                           icon="fas fa-sign-in-alt fa-1x"
                           hint="Move to Service"
                           (onClick)="mapAsService()"></dx-button>
                <dx-button *ngIf="currentUser.UserRoleId > 1 && !action?.data?.Active"
                           icon="fas fa-trash-restore fa-1x"
                           hint="Activate"
                           (onClick)="reactivate(action?.data?.ServiceAndProductMappingId)"></dx-button>
                <dx-button *ngIf="currentUser.UserRoleId > 1 && action?.data?.Active"
                           icon="fas fa-trash-alt fa-1x"
                           hint="Deactivate"
                           (onClick)="deactivate(action?.data?.ServiceAndProductMappingId)"></dx-button>
            </div>

            <div *dxTemplate="let data of 'detail'">
                <div class="master-detail-caption"></div>
                <app-transaction-detail [key]="data.key"></app-transaction-detail>
            </div>
            <dxo-paging [pageSize]="5"></dxo-paging>
            <!-- <dxo-summary [calculateCustomSummary]="calculateSummary">
        <dxi-total-item
            name="totalMappingItemCount"
            summaryType="custom"
            showInColumn="ServiceAndProductMappingId"
            displayFormat="Count: {0}">
        </dxi-total-item>
    </dxo-summary> -->
        </dx-data-grid>
    </div>
</div>

<div class="">
    <div dragula="HANDLES" id="left">
        <div class="mapping-grid-container shadow-lg mt-2">
            <span class="handle"><i class="fa fa-arrows" aria-hidden="true"></i></span>
            <div class="py-2 h-full">
                <dx-data-grid
                #productToMasterGrid
                id="productToMasterGrid"
                [allowColumnResizing]="true"
                [columnResizingMode]="'widget'"
                [allowColumnReordering]="true"
                [dataSource]="productToMasterData"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [cacheEnabled]="false"
                (onContextMenuPreparing)="productToMasterContextMenu($event)"
                keyExpr="CurrentMappingModeId">
                    <dxo-load-panel
                        [enabled]="false"
                        shadingColor="rgba(0,0,0,0.4)"
                        [showIndicator]="true"
                        [showPane]="true"
                        [shading]="true">
                    </dxo-load-panel>
                    <dxi-column dataField="MappingSource" caption="Mappings"></dxi-column>
                    <dxi-column caption="Action" cellTemplate="action" alignment="center"></dxi-column>
                    <dxi-column dataField="ProductMasterId" [customizeText]="customizeProductMasterId"></dxi-column>
                    <dxi-column dataField="CompanyName"></dxi-column>
                    <dxi-column dataField="MasterBrandName"></dxi-column>
                    <dxi-column dataField="BrandName"></dxi-column>
                    <dxi-column dataField="SubBrandName" caption="Sub-brand"></dxi-column>
                    <dxi-column dataField="ProductName" caption="Product"></dxi-column>
                    <dxi-column dataField="ProductIsNatureInspired"></dxi-column>
                    <dxi-column dataField="ProductIsMensProduct"></dxi-column>
                    <dxi-column dataField="CategoryName"></dxi-column>
                    <dxi-column dataField="SubcategoryFunctionName"></dxi-column>
                    <dxi-column dataField="SubcategoryFormName"></dxi-column>
                    <dxi-column dataField="ProductSizeOnLabel"></dxi-column>
                    <dxi-column dataField="CleanBarcode"></dxi-column>

                    <div *dxTemplate="let action of 'action'">
                        <dx-button
                            id="btnOmit"
                            *ngIf="action?.data?.Ranking == -1"
                            class="mr-1"
                            icon="fas fa-ban fa-1x"
                            hint="Omit"
                            [disabled]="action?.data?.CurrentMappingModeId == 3"
                            (onClick)="omit()"></dx-button>
                        <dx-button
                            id="btnSave"
                            *ngIf="action?.data?.Ranking == -1"
                            class="mr-1"
                            icon="far fa-bookmark fa-1x"
                            hint="Save"
                            [disabled]="action?.data?.CurrentMappingModeId == 2"
                            (onClick)="save()"></dx-button>
                        <dx-button
                            id="btnAccept"
                            *ngIf="action?.data?.Ranking == -1 && !(productMappingSelectedRowData.ModifiedByUserId > 0 || (action?.data?.CurrentMappingModeId == 0 && action?.data?.CurrentProductMasterId == 0))"
                            class="mr-1"
                            icon="fa fa-check fa-1x"
                            hint="Accept"
                            (onClick)="accept()"></dx-button>
                            <!-- need icon -->
                        <dx-button
                            id="btnReview"
                            *ngIf="
                                action?.data?.Ranking == -1 &&
                                currentUser.UserRoleId > 1 &&
                                productMappingSelectedRowData.MappingModeId !== 0 &&
                                productMappingSelectedRowData.ModifiedByUserId > 0 &&
                                productMappingSelectedRowData.ModifiedByUserId !== currentUser.UserId &&
                                productMappingSelectedRowData.ReviewedByUserId == -1"
                            class="mr-1"
                            icon="fas fa-check-double fa-1x"
                            hint="Review"
                            (onClick)="review()"></dx-button>
                        <dx-button
                            id="btnAcceptOmit"
                            *ngIf="action?.data?.Ranking >= 0 && action?.data?.MappingModeId == 3 && (action?.data?.Ranking > 0 || action?.data?.IsValidBarcode) && action?.data?.CurrentMappingModeId !== 3"
                            class="mr-1"
                            icon="fas fa-ban fa-1x"
                            hint="Accept Omit"
                            (onClick)="omit()"></dx-button>
                            <!-- need icon -->
                        <dx-button
                            id="btnAcceptSave"
                            *ngIf="action?.data?.Ranking >= 0 && action?.data?.MappingModeId == 2 && (action?.data?.Ranking > 0 || action?.data?.IsValidBarcode) && action?.data?.CurrentMappingModeId !== 2"
                            class="mr-1"
                            icon="far fa-bookmark fa-1x"
                            hint="Accept Save"
                            (onClick)="save()"></dx-button>
                            <!-- need icon -->
                        <dx-button
                            id="btnAcceptMapping"
                            *ngIf="action?.data?.Ranking >= 0 && action?.data?.MappingModeId == 1 && (action?.data?.ProductMasterId && action?.data?.ProductMasterId != 0) && action?.data?.CurrentProductMasterId !== action?.data?.ProductMasterId"
                            class="mr-1"
                            icon="fas fa-map-marker-alt fa-1x"
                            hint="Accept Mapping"
                            (onClick)="acceptMapping(action?.data?.ProductMasterId)"></dx-button>
                            <!-- need icon -->
                        <ng-container *ngIf="action?.data?.MappingSource === 'Barcode Mapping'">
                            <i class="fas fa-concierge-bell text-xl" style="font-size: 1.25rem;" *ngIf="isEligibleForBarcodeMapping(action?.data)" title="Right-click for more"></i>
                        </ng-container>
                    </div>
                </dx-data-grid>
            </div>
        </div>
        <div class="mapping-grid-container shadow-lg mt-2">
            <div class="flex">
                <span class="handle mr-3"><i class="fa fa-arrows" aria-hidden="true"></i></span>
                <button type="button" class="btn btn-light btn-create-product" (click)="createProduct()"><i class="fa fa-plus" aria-hidden="true"></i></button>
            </div>
            <app-product-master-data-grid
                masterGridName="productMasterDataGrid"
                pageName="productMapping"
                [isCreateProduct]="isCreateProduct"
                (productMappingSelectionChanged) = "productMappingSelectionChanged($event)"
                (productCreateModalClosed)="isCreateProduct = false"
                (onProductMasterDataGridLoaded)="productMasterGridLoadingHandler($event)"
                (onMap)="map($event)"
            ></app-product-master-data-grid>
        </div>
    </div>
</div>
